import * as z from "zod";
import { userFacingError } from "../authorization";
import { ownConnectorGrants } from "../connectors/ownConnectorGrants";
import { mutator } from "./mutator";

const revokeOwnConnectorGrantSchema = z.object({
  oauthConnectionId: z.string(),
});

export const revokeOwnConnectorGrant = mutator({
  schema: revokeOwnConnectorGrantSchema,
  resolve: {
    grant: { kind: "oauthConnection", from: "oauthConnectionId" },
  },
  permissions: {
    none: "deletes a visitor grant whose subject is the caller or the caller’s email",
  },
  fn: async ({ tx, ctx, args: { grant } }) => {
    const ownGrant = await tx.run(
      ownConnectorGrants(ctx, grant.subjectId ?? undefined)
        .where("id", grant.id)
        .one()
    );
    if (!ownGrant) {
      throw userFacingError("Grant not found");
    }
    await tx.mutate.oauthConnections.delete({ id: grant.id });
  },
});
